import { Footer } from "@layouts/Footer";
import { NotFoundHero } from "./components/NotFoundHero";
import { QuickLinksSection } from "./components/QuickLinksSection";

export function NotFound() {
  return (
    <div className="w-full flex flex-col items-start bg-white">
      <NotFoundHero />
      <QuickLinksSection />
      <Footer />
    </div>
  );
}

export default NotFound;
